/* eslint-disable no-console */
import { API } from 'aws-amplify';
import { Relation, RelationsResponse } from './types';

// API endpoint name as configured in Amplify
const API_NAME = 'revisedResources';

/**
 * Get all relations for a specific company
 * @param companyId - Company identifier
 * @returns List of relations
 */
export const getRelations = async (
  companyId: string
): Promise<Relation[]> => {
  if (!companyId) {
    console.error('Company ID is required for getRelations');
    throw new Error('Company ID is required');
  }

  try {
    const response = await API.get(
      API_NAME,
      `/relations/company/${companyId}`,
      {}
    ) as RelationsResponse;
    
    // If the API call was successful and we got data
    if (response?.success && response?.data) {
      return response.data;
    }
    
    // If the response format is unexpected or API returned an error
    console.warn('Unexpected response format from getRelations:', response);
    return [];
  } catch (error) {
    console.error('Error getting relations:', error);
    throw error;
  }
};

/**
 * Get a specific relation by ID
 * @param relationId - Relation identifier
 * @returns The relation data
 */
export const getRelationById = async (
  relationId: string
): Promise<Relation> => {
  if (!relationId) {
    console.error('Relation ID is required for getRelationById');
    throw new Error('Relation ID is required');
  }

  try {
    const response = await API.get(
      API_NAME,
      `/relations/${relationId}`,
      {}
    ) as RelationsResponse;
    
    // If the API call was successful and we got data
    if (response?.success && response?.data && Array.isArray(response.data) && response.data.length > 0) {
      return response.data[0];
    }
    
    // If the response format is unexpected or API returned an error
    console.warn('Unexpected response format from getRelationById:', response);
    throw new Error('Failed to get relation');
  } catch (error) {
    console.error('Error getting relation by ID:', error);
    throw error;
  }
}; 